import { Injectable } from '@angular/core';
import { BusinessTransactionType } from '@max/foundation/models/enums/business-transaction-type.enum';
import { ISourceSystemType } from '../../../foundation/models/enums/source-system-type.enum';
import { TabObject } from '../../components/tabs/tabs.model';
import { RouteBuilderService } from './route-builder.service';

@Injectable()
export class AircraftRouteBuilderService extends RouteBuilderService {
    private businessTransactionTypes: BusinessTransactionType = new BusinessTransactionType();

    constructor() {
        super();
    }

    public get sourceSystemType(): ISourceSystemType {
        return this.sourceSystemTypes.Aircraft;
    }

    /**
     * Gets the route list for the transaction type provided.
     * @returns: Array of routes for transaction.
     */
    public getRouteList(businessTransactionTypeId: number): any[] {
        switch (businessTransactionTypeId) {
            case this.businessTransactionTypes.AddAircraftRegistration.id: {
                return this.getAddRegistrationRoutes();
            }
            case this.businessTransactionTypes.UpdAircraftRegistration.id: {
                return this.getUpdateRegistrationRoutes();
            }
            case this.businessTransactionTypes.PayAircraftInvoice.id: {
                return this.getPayRegistrationRoutes();
            }
            case this.businessTransactionTypes.AircraftAssessment.id: {
                return this.getAircraftAssessmentRoutes();
            }
            case this.businessTransactionTypes.ReactivateAircraftRegistration.id: {
                return this.getReactivateAircraftRegistrationRoutes();
            }
            case this.businessTransactionTypes.ChgAircraftOwnership.id: {
                return this.getChangeAircraftOwnershipRoutes();
            }
            default: {
                return [];
            }
        }
    }

    private getAddRegistrationRoutes = (): TabObject[] => [
        { name: 'aircraft-info', title: 'Aircraft', isActive: true, isHidden: false, route: null, hasTooltip: false, hasValidation: false },
        { name: 'aircraft-ownership-customer', title: 'Owners', isActive: false, isHidden: false, route: null, hasTooltip: false, hasValidation: false },
        { name: 'aircraft-registration', title: 'Registration', isActive: false, isHidden: false, route: null, hasTooltip: false, hasValidation: false },
        { name: 'aircraft-documents', title: 'Documents', isActive: false, isHidden: false, route: null, hasTooltip: false, hasValidation: false }
    ];

    private getUpdateRegistrationRoutes = (): TabObject[] => [
        { name: 'aircraft-info', title: 'Aircraft', isActive: true, isHidden: false, route: null, hasTooltip: false, hasValidation: false },
        { name: 'aircraft-ownership-customer', title: 'Owners', isActive: false, isHidden: false, route: null, hasTooltip: false, hasValidation: false },
        { name: 'aircraft-registration', title: 'Registration', isActive: false, isHidden: false, route: null, hasTooltip: false, hasValidation: false },
        { name: 'aircraft-documents', title: 'Documents', isActive: false, isHidden: false, route: null, hasTooltip: false, hasValidation: false }
    ];

    private getPayRegistrationRoutes = (): TabObject[] => [
        { name: 'aircraft-info', title: 'Aircraft', isActive: true, isHidden: false, route: null, hasTooltip: false, hasValidation: false },
        { name: 'aircraft-ownership-customer', title: 'Owners', isActive: false, isHidden: false, route: null, hasTooltip: false, hasValidation: false },
        { name: 'aircraft-registration', title: 'Registration', isActive: false, isHidden: false, route: null, hasTooltip: false, hasValidation: false },
        { name: 'aircraft-documents', title: 'Documents', isActive: false, isHidden: false, route: null, hasTooltip: false, hasValidation: false }
    ];

    private getAircraftAssessmentRoutes = (): TabObject[] => [
        { name: 'aircraft-info', title: 'Aircraft', isActive: true, isHidden: false, route: null, hasTooltip: false, hasValidation: false },
        { name: 'aircraft-ownership-customer', title: 'Owners', isActive: false, isHidden: false, route: null, hasTooltip: false, hasValidation: false },
        { name: 'aircraft-registration', title: 'Registration', isActive: false, isHidden: false, route: null, hasTooltip: false, hasValidation: false },
        { name: 'aircraft-documents', title: 'Documents', isActive: false, isHidden: false, route: null, hasTooltip: false, hasValidation: false }
    ];

    private getReactivateAircraftRegistrationRoutes = (): TabObject[] => [
        { name: 'aircraft-info', title: 'Aircraft', isActive: true, isHidden: false, route: null, hasTooltip: false, hasValidation: false },
        { name: 'aircraft-ownership-customer', title: 'Owners', isActive: false, isHidden: false, route: null, hasTooltip: false, hasValidation: false },
        { name: 'aircraft-registration', title: 'Registration', isActive: false, isHidden: false, route: null, hasTooltip: false, hasValidation: false },
        { name: 'aircraft-documents', title: 'Documents', isActive: false, isHidden: false, route: null, hasTooltip: false, hasValidation: false }
    ];

    private getChangeAircraftOwnershipRoutes = (): TabObject[] => [
        { name: 'aircraft-info', title: 'Aircraft', isActive: true, isHidden: false, route: null, hasTooltip: false, hasValidation: false },
        { name: 'aircraft-ownership-customer', title: 'Owners', isActive: false, isHidden: false, route: null, hasTooltip: false, hasValidation: false },
        { name: 'aircraft-registration', title: 'Registration', isActive: false, isHidden: false, route: null, hasTooltip: false, hasValidation: false },
        { name: 'aircraft-documents', title: 'Documents', isActive: false, isHidden: false, route: null, hasTooltip: false, hasValidation: false }
    ];
}
